<script lang="ts" setup>
import i18n from '@/locales'

interface Props {
  type: 'error' | 'success'
  title?: string
  message: string
  duration?: number
}

const props = withDefaults(defineProps<Props>(), {
  type: 'success',
  title: i18n.global.t('Notifications'),
  message: i18n.global.t('LaunchSuccess'),
  duration: 1500
})

const emit = defineEmits(['close'])

// 控制顯示狀態
const isShow = ref(true)

const show = (): void => {
  isShow.value = true

  if (props.duration !== 0) {
    setTimeout(() => {
      close()
    }, props.duration)
  }
}

const close = (): void => {
  isShow.value = false
  emit('close')
}

onMounted(() => {
  show()
})

// 監控組件卸載時的行為
onUnmounted(() => {
  isShow.value = false
})

// 自動觸發顯示
watch(isShow, (newVal) => {
  if (newVal) {
    show()
  }
})
</script>

<template>
  <div v-if="isShow" class="toast-popup-wrap">
    <div
      :class="[
        'toast',
        type === 'success' ? 'success' : 'error',
        { show: isShow }
      ]"
    >
      <div class="toast-header">
        <h4>{{ title }}</h4>
        <i class="icons-cancel-gray" @click="close"></i>
      </div>
      <div class="toast-body text-sm">{{ message }}</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.toast-popup-wrap {
  @apply fixed w-[380px] right-2 top-0 p-[20px] pr-0 m-0 z-[99999];

  opacity: 1;
  transition: opacity 0.15s linear;

  .toast {
    @apply w-[350px] p-[20px] rounded-lg text-sm;

    background-clip: padding-box;
    box-shadow: 0 0.25rem 0.75rem rgb(0 0 0 / 10%);
    opacity: 0;

    h4 {
      @apply text-lg font-semibold leading-tight;

      margin: 0 auto 0 0;
    }

    .toast-header {
      @apply flex items-center pb-[10px];
    }

    .toast-body {
      padding: 0 0 0 30px;
    }

    &.show {
      display: block;
      opacity: 1;
      transition: opacity 0.15s linear;
    }
  }

  .success {
    background-color: #c9ffaf;
    border: 1px solid #4a752f;

    h4 {
      color: #4a752f;
    }
  }
  .error {
    background-color: #facfd7;
    border: 1px solid #d9415a;

    h4 {
      color: #d9415a;
    }
  }
}
</style>
